import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['fileInput']

  submit(event) {
    this.fileInputTarget.name = `order[${event.target.value}_signature]`
  }
}
